import Insight from "../insightClass";
import React from "react";
import { insight27Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight053 = new Insight(
  "04 July 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight27Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-07-04)",
  "",
  `The Crown Estate reported £1.15 billion in profit for FY 2024/25, largely driven by Round 4 offshore wind leasing (£1.07 b). Revenues are expected to drop to ~£25 million annually from 2026, raising concerns about long-term funding stability.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-07-04)</h1>
    <h2></h2>
    <p className="article-date">04 July 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>

    <h3>
      1. Crown Estate posts £1.15 b profit, reliant on offshore wind leases
    </h3>
    <p>
      The Crown Estate reported £1.15 billion in profit for FY 2024/25, largely
      driven by Round 4 offshore wind leasing (£1.07 b). Revenues are expected
      to drop to ~£25 million annually from 2026, raising concerns about
      long-term funding stability.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This highlights the need for a consistent leasing programme and
      diversified income streams to avoid dependency on periodic leasing peaks.
    </p>
    <h3>2. Equinor and Polenergia’s Baltic Sea projects enter construction</h3>
    <p>
      Equinor and Polenergia have commenced construction of the 1.44 GW Bałtyk
      II and III offshore wind farms in the Polish Baltic Sea. Foundations are
      being installed, and commercial operations are expected to begin in 2027.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      oland's offshore wind sector has reached a strategic inflection point.
      This move establishes its credibility as a Baltic market leader and
      attracts broader investor interest.
    </p>
    <h3>3. Germany’s Nextwind raises €1.4 b to scale wind portfolio</h3>
    <p>
      Nextwind secured €1.4 billion in debt financing, with potential for
      €1.3 billion more upon meeting milestones. The company aims to increase
      wind capacity to 3 GW by 2028, marking Germany’s largest private-sector
      wind deal.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This demonstrates strong investor appetite for independent wind developers
      and reinforces Germany’s position as a core wind investment hub.
    </p>
    <h3>4. Belgium halts 700 MW offshore wind tender</h3>
    <p>
      The Belgian government unexpectedly paused its 700 MW Princess Elisabeth
      Zone tender due to rising costs, catching the industry off guard after
      extensive planning and prequalification stages.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Cost inflation has the power to derail even mature tender processes. Risk
      mitigation and indexation mechanisms are becoming increasingly vital.
    </p>
    <h3>5. Sweden grants cable export permits for 1.8 GW offshore wind</h3>
    <p>
      Sweden approved export cable permits for two offshore wind farms totaling
      1.8 GW. This regulatory clearance paves the way for grid integration and
      offtake agreement structuring.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The decision reduces permitting uncertainty and may position Sweden as a
      new high-potential offshore wind player in Northern Europe.
    </p>
    <h3>6. European renewables stocks rise after US tax policy extension</h3>
    <p>
      The US Senate extended tax credits for renewable energy projects that
      begin before 2026. European wind companies like Ørsted, Vestas, and RWE
      saw share prices jump following the announcement.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This policy shift provides greater certainty and improves project
      bankability, prompting European developers to accelerate US-facing
      investments and supply agreements.
    </p>
    <h3>7. Ørsted terminates installation vessel contract with Cadeler</h3>
    <p>
      Ørsted cancelled its contract with Cadeler for an installation vessel,
      citing delays. The vessel, intended for offshore wind projects in Asia,
      faced scheduling issues following Cadeler’s restructuring.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Vessel supply chain fragility remains a key bottleneck in Asia-Pacific
      offshore wind growth. Developers may seek diversification in marine asset
      procurement to mitigate similar risks.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
